import { render, staticRenderFns } from "./HeaderConf.vue?vue&type=template&id=72e3f278"
import script from "./HeaderConf.vue?vue&type=script&lang=js"
export * from "./HeaderConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports